import React, { memo, useMemo } from 'react'

import './index.scss'

const StopSpeedCol = memo(({ val, data }) => {
  const valueElem = useMemo(() => {
    const speed = parseFloat(val).toFixed(1)
    const lookup = { class: [], value: `${speed} km/h` }
    if (speed === 0 && data.stop_start_date) {
      const stopDate = data.stop_start_date
      lookup.value = 0
    } else if (speed > 0) {
      lookup.class.push('speed')
    }

    return lookup
  }, [val, data])

  if (!val) return ''

  return (
    <div className={`StopSpeedCol ${valueElem.class.length ? valueElem.class.join(' ') : ''}`}>
      {valueElem.value}
    </div>
  )
})

export default StopSpeedCol
